var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertWarn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    className: "injected-svg",
    "data-src": "assets/ws10/icons/SourceStateIcons/warn-inverse.svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 192,
    height: 192,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m173.07 136.36-56-103.71a24 24 0 0 0-42.12 0L19 136.32a24 24 0 0 0 21 35.52h112a24 24 0 0 0 21.07-35.48ZM92 63.86a4 4 0 0 1 8 0v56.5a4 4 0 1 1-8 0Zm4 81a5 5 0 1 1 5-5 5 5 0 0 1-5 5Z",
    fill: "#FFFFFF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertWarn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alert_warn.526dd849123fe54643909c5887488cf1.svg";